import cx from 'classnames';
import * as React from 'react';
import type { FieldError } from 'react-hook-form';
import { FormErrorIcon } from './form.error-icon';
import { Text } from '@dx-ui/global-ui-prism';

type FormError = {
  error?: Partial<FieldError>;
} & React.ComponentProps<'div'>;

/**
 * The standard error message to be used for forms and form inputs
 */
const FormError = ({ ref, error, className, ...rest }: FormError) => {
  const messages = (error?.types ? Object.values(error.types) : [error?.message]).filter(
    (v) => typeof v === 'string'
  );
  const hasError = messages.length > 0;

  return (
    <div
      ref={ref}
      className={cx(className, {
        hidden: !hasError,
        block: hasError,
      })}
      {...rest}
    >
      {hasError && (
        <div className="flex flex-col space-y-2">
          {messages.map((message) => (
            <div key={String(message)} className="mt-1 flex items-center">
              <FormErrorIcon />
              <Text as="span" size="sm" className="text-surface-error">
                {message}
              </Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { FormError };
export default FormError;
